import { render, staticRenderFns } from "./company-info-linkman.vue?vue&type=template&id=7f6bc4ec&scoped=true&"
import script from "./company-info-linkman.vue?vue&type=script&lang=js&"
export * from "./company-info-linkman.vue?vue&type=script&lang=js&"
import style0 from "./company-info-linkman.vue?vue&type=style&index=0&id=7f6bc4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6bc4ec",
  null
  
)

export default component.exports